/**
 * @module builder
 */
import type { QuoteDocument, OptionsDocument } from 'paintscout'
import find from 'lodash/find'
import { getQuoteTypeOptions } from '../../../options'
import { getInitialTerms } from '../../terms'

export function setQuoteType(args: {
  quote: QuoteDocument
  options: OptionsDocument
  quoteType: string
}): QuoteDocument {
  const { quote, options, quoteType } = args

  const quoteTypeOptions = getQuoteTypeOptions({ options })
  const quoteTypeOption = find(quoteTypeOptions, { key: quoteType })

  if (!quoteTypeOption) {
    return quote
  }

  const terms =
    quoteTypeOption.defaultTerms && quote.terms?.name !== quoteTypeOption.defaultTerms
      ? getInitialTerms({ options, quoteType: quoteTypeOption, invoice: quote.is_invoice }) ?? quote.terms
      : quote.terms

  const updatedQuote = {
    ...quote,
    int_ext: {
      ...quoteTypeOption,
      value: quoteTypeOption.key
    },
    terms
  }

  return updatedQuote
}
